import React from "react"; //ga tracker

import gaTracker from '../../../util/ga-analytics/gaTracker';
export var RadioButton = function RadioButton(_ref) {
  var name = _ref.name,
      id = _ref.id,
      value = _ref.value,
      checked = _ref.checked,
      _onChange = _ref.onChange,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      _ref$labelClass = _ref.labelClass,
      labelClass = _ref$labelClass === void 0 ? "" : _ref$labelClass,
      children = _ref.children,
      disabled = _ref.disabled;

  var radioClick = function radioClick() {
    _onChange;
    var data = {
      gtm: {
        uniqueEventId: 114,
        elementTarget: value,
        elementId: id
      },
      event: 'gtm.click'
    };
    gaTracker(data);
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "cb-cart__travel cb-form__radio ".concat(className, " ").concat(disabled ? 'disabled' : '')
  }, /*#__PURE__*/React.createElement("input", {
    type: "radio",
    name: name,
    id: id,
    value: value,
    checked: checked,
    disabled: disabled,
    onChange: function onChange(e) {
      _onChange(e);

      radioClick();
    }
  }), /*#__PURE__*/React.createElement("label", {
    htmlFor: id,
    className: labelClass,
    onClick: function onClick(e) {
      if (!disabled) {
        _onChange(e);
      }
    }
  }), /*#__PURE__*/React.createElement("div", null, children));
};